"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderStatus = void 0;
var React = require("react");
/**
 * @private
 * Renders an empty DOM node to use as a hook for UI Automation Testing.
 *
 * During server-side rendering it will output with:
 *   `data-stid="render-status--static"`
 *
 * After JS loads and the application mounts in the browser it will change to:
 *   `data-stid="render-status--hydrated"`
 */
var RenderStatus = function () {
    var _a = __read(React.useState(false), 2), hydrated = _a[0], setHydrated = _a[1];
    React.useEffect(function () {
        setHydrated(true);
    });
    return React.createElement("div", { "data-stid": "render-status--".concat(hydrated ? 'hydrated' : 'static') });
};
exports.RenderStatus = RenderStatus;
//# sourceMappingURL=render-status.js.map